export const transitionDurationShort = 50;
export const transitionDurationMiddle = 150;
export const transitionDuration = 250;
export const transitionDurationLong = 500;

export const zIndexBrand = 1000;
export const zIndexModal = 999;
export const zIndexOffCanvas = 100;
export const zIndexCatalogue = 99;
export const zIndexUiElem = 50;
export const zIndexHeadline = 20;
export const zIndexStickyTop = 11;
export const zIndexContent = 10;
export const zIndexOverlay = 4;
export const zIndexTop = 3;
export const zIndexFront = 2;
export const zIndex = 1;
export const zIndexHide = -1;

export const transitionTiming = 'cubic-bezier(0.75, 0.02, 0.5, 1)';
